import React from 'react';
import { useNavigate } from 'react-router-dom';

interface CartErrorStateProps {
  error: string | null;
}

const CartErrorState: React.FC<CartErrorStateProps> = ({ error }) => {
  const navigate = useNavigate();

  return (
    <>
      <div className="min-h-screen bg-black pt-24 pb-8 flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-white mb-4">Error Loading Cart</h2>
          <p className="text-gray-400 mb-4">{error || 'Cart not found'}</p>
          <button 
            onClick={() => navigate('/carts')}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            Back to Carts
          </button>
        </div>
      </div>
    </>
  );
};

export default CartErrorState;

